import { Link } from 'react-router-dom';
import { FaHome, FaTruck, FaBuilding, FaGlobe, FaBoxes, FaArrowRight, FaPhone } from 'react-icons/fa';
import styles from '../styles/pages.module.css';

export default function Servicios() {
  const servicios = [
    {
      id: 'local',
      numero: '01',
      icon: FaHome,
      imagen: '/assets/images/carousel-2.webp',
      titulo: 'Mudanzas locales',
      descripcion: 'Rápidas, cuidadosas y sin complicaciones. En Móstoles, Madrid y toda el área metropolitana.',
      bullets: [
        'Embalaje profesional incluido',
        'Furgoneta con conductor cualificado',
        'Montaje y desmontaje de muebles',
        'Precios cerrados desde 150€'
      ]
    },
    {
      id: 'nacional',
      numero: '02',
      icon: FaTruck,
      imagen: '/assets/images/carousel-1.webp',
      titulo: 'Mudanzas nacionales',
      descripcion: 'Llegamos a cualquier punto de España con rutas optimizadas y seguimiento permanente.',
      bullets: [
        'Cobertura en toda la península y Baleares',
        'Ruta directa sin transbordos',
        'Entrega en plazos acordados',
        'Seguro a todo riesgo incluido'
      ]
    },
    {
      id: 'empresas',
      numero: '03',
      icon: FaBuilding,
      imagen: '/assets/images/carousel-5.webp',
      titulo: 'Mudanzas de empresa',
      descripcion: 'Trasladamos tu oficina sin interrumpir tu actividad. Fines de semana, noches o lo que necesites.',
      bullets: [
        'Planificación fuera de horario laboral',
        'Desmontaje e instalación de equipamiento',
        'Etiquetado y organización por departamento',
        'Coordinación con tu equipo de IT'
      ]
    },
    {
      id: 'internacional',
      numero: '04',
      icon: FaGlobe,
      imagen: '/assets/images/carousel-4.webp',
      titulo: 'Mudanzas internacionales',
      descripcion: 'Portugal, Francia, Italia y más. Te acompañamos en todo el proceso, incluida la documentación.',
      bullets: [
        'Gestión aduanera y documental',
        'Embalaje reforzado para viajes largos',
        'Seguimiento en tiempo real',
        'Red de agentes en Europa'
      ]
    },
    {
      id: 'guardamuebles',
      numero: '05',
      icon: FaBoxes,
      imagen: '/assets/images/carousel-3.webp',
      titulo: 'Guardamuebles',
      descripcion: 'Cuando necesitas tiempo entre una mudanza y otra. Almacén seguro, limpio y con acceso flexible.',
      bullets: [
        'Instalaciones climatizadas y vigiladas',
        'Acceso cuando lo necesites',
        'Trasteros de distintos tamaños',
        'Tarifas desde 40€/mes'
      ]
    }
  ];

  return (
    <div style={{ background: '#FAF7F2' }}>
      {/* Hero */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <span className={styles.eyebrow} style={{ color: '#FFB380' }}>Nuestros servicios</span>
          <h1>Lo movemos todo, lo cuidamos todo</h1>
          <p>Desde un estudio en Móstoles hasta un traslado internacional. Tenemos una solución para cada mudanza.</p>
        </div>
      </section>

      {/* Servicios */}
      <section style={{ padding: '5rem 0' }}>
        <div className={styles.container}>
          {servicios.map((s, idx) => (
            <div
              key={s.id}
              className={styles.splitGrid}
              style={{ marginBottom: idx < servicios.length - 1 ? '5rem' : '0' }}
            >
              <div style={{ order: idx % 2 === 0 ? 1 : 2 }}>
                <span className={styles.eyebrow}>{s.numero} · {s.titulo.toLowerCase()}</span>
                <h2 style={{
                  fontSize: '2.25rem',
                  margin: '1rem 0 1.25rem',
                  lineHeight: 1.15,
                  letterSpacing: '-0.02em'
                }}>
                  {s.titulo}
                </h2>
                <p style={{
                  fontSize: '1.05rem',
                  color: '#4A4A4A',
                  lineHeight: 1.7,
                  marginBottom: '1.5rem'
                }}>
                  {s.descripcion}
                </p>
                <ul style={{ listStyle: 'none', padding: 0, marginBottom: '2rem' }}>
                  {s.bullets.map((b, i) => (
                    <li key={i} style={{
                      position: 'relative',
                      paddingLeft: '1.5rem',
                      marginBottom: '0.75rem',
                      color: '#1A1A1A',
                      fontWeight: 500,
                      fontSize: '0.95rem'
                    }}>
                      <span style={{
                        position: 'absolute',
                        left: 0,
                        color: '#D97441',
                        fontWeight: 700
                      }}>✓</span>
                      {b}
                    </li>
                  ))}
                </ul>
                <Link to="/presupuesto" className={styles.btnPrimary}>
                  Pedir presupuesto <FaArrowRight />
                </Link>
              </div>
              <div
                className={`${styles.splitImage} ${styles.splitImageAspect43}`}
                style={{ order: idx % 2 === 0 ? 2 : 1 }}
              >
                <img src={s.imagen} alt={s.titulo} />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className={styles.finalCta}>
        <div className={styles.container}>
          <div className={styles.finalCtaBox}>
            <h2>¿No encuentras lo que buscas?</h2>
            <p>Cuéntanos tu caso. Seguro que podemos ayudarte.</p>
            <div className={styles.finalCtaButtons}>
              <Link to="/contacto" className={styles.btnPrimary}>
                Contactar
              </Link>
              <a href="tel:+34691604880" className={styles.btnGhostDark}>
                <FaPhone /> 691 60 48 80
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
